module.exports = __webpack_public_path__ + "static/nikki_headshot_cropped-d61a5ca99247998a21686fd47e75d96c.jpg";